var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.81195V13.902L20.37 12.502C19.59 11.832 18.33 11.832 17.55 12.502L13.39 16.072C12.61 16.742 11.35 16.742 10.57 16.072L10.23 15.792C9.52 15.172 8.39 15.112 7.59 15.652L2.67 18.952L2.56 19.032C2.19 18.232 2 17.282 2 16.192V7.81195C2 4.17195 4.17 2.00195 7.81 2.00195H16.19C19.83 2.00195 22 4.17195 22 7.81195Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00109 10.3811C10.3155 10.3811 11.3811 9.31553 11.3811 8.00109C11.3811 6.68666 10.3155 5.62109 9.00109 5.62109C7.68666 5.62109 6.62109 6.68666 6.62109 8.00109C6.62109 9.31553 7.68666 10.3811 9.00109 10.3811Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9986 13.9025V16.1925C21.9986 19.8325 19.8286 22.0025 16.1886 22.0025H7.80859C5.25859 22.0025 3.41859 20.9325 2.55859 19.0325L2.66859 18.9525L7.58859 15.6525C8.38859 15.1125 9.51859 15.1725 10.2286 15.7925L10.5686 16.0725C11.3486 16.7425 12.6086 16.7425 13.3886 16.0725L17.5486 12.5025C18.3286 11.8325 19.5886 11.8325 20.3686 12.5025L21.9986 13.9025Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.3f1bffae1aee9655ce948ac909c0f7a9.svg";
export { ForwardRef as ReactComponent };